export const btnFontWeight = '400'
export const btnHeightBase = '42px'
export const btnHeightLg = '50px'
export const btnHeightSm = '34px'

export const btnDefaultColor = 'white'
export const btnDefaultBg = '#ADB6CC'
export const btnDefaultBorder = '#98a1b5'
